let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");


module.exports = dd.createClass({

  render(){
    let {email_template, onClose} = this.props;

    return Modal({
        title: "Previewing email: " + _.get(email_template, ['name']),
        onClose: onClose(null),
        buttons: []
      },
      dd.div({className: "clearfix"}),
      dd.div({style: {padding: '5px 0px'}},
        "Subject:"
      ),
      dd.div({style: {padding: '8px', border: '1px solid #ccc', width: '100%'}},
        email_template.subject
      ),
      dd.div({style: {padding: '5px 0px'}},
        "Body:"
      ),
      dd.div({dangerouslySetInnerHTML: {__html: email_template.body, html: email_template.body}, style: {padding: '8px', border: '1px solid #ccc'}}),
      dd.div({className: "clearfix"})
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/action_list/EmailTemplatePreviewModal.js